/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalAccountant from './hospital-accountant';
import HospitalAccountantDetail from './hospital-accountant-detail';
import HospitalAccountantUpdate from './hospital-accountant-update';
import HospitalAccountantDeleteDialog from './hospital-accountant-delete-dialog';

const HospitalAccountantRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalAccountant />} />
    <Route path="new" element={<HospitalAccountantUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalAccountantDetail />} />
      <Route path="edit" element={<HospitalAccountantUpdate />} />
      <Route path="delete" element={<HospitalAccountantDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalAccountantRoutes;
